'use strict';
module.exports = function($) {
  return $.fn.ready = (function(proceed) {
    return function(unsafe) {
      var safely;
      safely = function() {
        var e, err, msg;
        try {
          return unsafe.apply(this, arguments);
        } catch (error) {
          e = error;
          msg = 'Exception in a jQuery.ready callback: ';
          if (window.console && typeof console.error === 'function') {
            console.error(msg, e);
          } else {
            err = new Error(msg + e.message);
            err.original = e;
            setTimeout((function() {
              throw err;
            }), 0);
          }
        }
      };
      return proceed(safely);
    };
  })($.fn.ready);
};

